import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Button from '../../buttons/IconButton';//eslint-disable-line import/no-named-as-default
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as appDataActions from '../../../actions/appDataActions';
import * as userDataActions from '../../../actions/userDataActions';
import * as appHelper from '../../../helpers/appHelper';
import * as appConstants from '../../../constants/appConstants';
import * as objectConstants from '../../../constants/objectConstants';
import * as assetConstants from '../../../constants/assetConstants';
import * as localStorage from '../../../localStorage/localStorage';
import {TweenLite, Elastic, Bounce, Expo} from 'gsap';
import gsap from 'gsap-react-plugin';
import _ from 'lodash';

class TitleScreen extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            screen: this.props.screen,
            show_project_title: appHelper.isDefined(this.props.screen.show_project_title) ? this.props.screen.show_project_title : true,
            locale: {},
            renderedObjects: [],
            assets: {
                background: {
                    src: "",

                },
                icon: {
                    src: "",
                }
            },
            isDisabled: false,
            start_label: appHelper.getLocaleString("start_label"),
            continue_label: appHelper.getLocaleString("continue_label")
        };
        this.getLocale = this.getLocale.bind(this);
        this.getScreenId = this.getScreenId.bind(this);
        this.getBiteId = this.getBiteId.bind(this);
        this.getAssets = this.getAssets.bind(this);
        this.getImagePath = this.getImagePath.bind(this);
        this.onProgressionClicked = this.onProgressionClicked.bind(this);
        this.navigateToNextScreen = this.navigateToNextScreen.bind(this);
        this.setClass = this.setClass.bind(this);
        this.getButtonLabel = this.getButtonLabel.bind(this);
        this.updateScreenResults = _.debounce(this.updateScreenResults.bind(this), 300);
        this.setScreenAccessed = _.debounce(this.setScreenAccessed.bind(this), 300);
    }

    componentDidMount() {
        this.setScreenAccessed();
        this.props.biteCallbacks.showHeader(false);
        this.getLocale();
        this.getAssets();
        setTimeout(function () {
            this.updateScreenResults(objectConstants.STATUS_COMPLETE);
        }.bind(this), 1000);
    }

    componentWillReceiveProps(nextProps) {
        if(this.state.lang !== nextProps.lang){
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.state.screen),
                start_label: appHelper.getLocaleString("start_label"),
                continue_label: appHelper.getLocaleString("continue_label")
            });
        }
    }

    setScreenAccessed(){
        this.props.actions.setScreenAccessed(this.state.screen);
    }

    getLocale() {
        let locale = appHelper.getLocalData(this.state.screen);
        this.props.actions.setScreenTitle(locale.title);
        this.setState({locale: Object.assign({}, locale)});
    }


    getAssets() {
        let background = {};
        let icon = {};
        if (appHelper.isDefined(this.state.screen.assets.background)) {
            background = appHelper.getBackgroundAsset(this.state.screen.assets.background);

        }
        if (appHelper.isDefined(this.state.screen.assets.icon)) {
            if(this.state.screen.assets.icon.constant === assetConstants.ASSET_TYPE_ICON){
                icon = appHelper.getIconAsset(this.state.screen.assets.icon);
            }else if(this.state.screen.assets.icon.constant === assetConstants.ASSET_TYPE_LIBRARY_IMAGE){
                icon = appHelper.getLibraryImageAsset(this.state.screen.assets.icon);
            }

        }

        this.setState({
            assets: Object.assign({}, this.state.assets, {
                background: appHelper.isDefined(background.src) ? background : this.state.assets.background,
                icon: appHelper.isDefined(icon.src) ? icon : this.state.assets.icon
            })
        });
    }

    getImagePath(image) {
        if (appConstants.DEVELOPMENT_MODE) {
            if (appHelper.isDefined(image) && image.length > 0) {
                return require(`../../../../moveToDist/${image}`);
            }
        } else {
            return image;
        }
    }

    getScreenId() {
        return this.state.screen.screen_id;
    }

    getBiteId() {
        return this.props.biteCallbacks.getBiteId();
    }

    updateScreenResults(screen_status) {
        let params = {
            bite_id: this.getBiteId(),
            screen_id: this.getScreenId(),
            screen_status: screen_status
        };

        this.props.actions.updateScreenResults(params).then((userData) => {
            this.props.actions.setSuspendData(userData).then((trackingData) => {
                if(screen_status === objectConstants.STATUS_COMPLETE){
                    this.props.actions.setScreenComplete(this.state.screen);
                }
            }).catch(error => {
            });
        }).catch(error => {
        });
    }

    onProgressionClicked() {
        this.setState({isDisabled: true});

        this.navigateToNextScreen();
    }

    navigateToNextScreen() {
        let nextScreenId = appHelper.getNextScreenId(this.getScreenId());
        if (localStorage.bites.length > 1 && nextScreenId.length === 0) {
            this.context.router.push('menu');
        } else {
            this.props.actions.setNextLessonLocation(this.getScreenId());
        }
    }

    setClass() {
        return this.state.screen.include_logo ? "logo" : "";
    }

    getButtonLabel() {
        let bite = appHelper.getBiteById(this.getBiteId());
        if (bite.location_order === 1 & this.state.screen.display_order_id === 1) {
            return this.state.start_label;
        } else {
            return this.state.continue_label;
        }
    }

    render() {

        return (
            appHelper.isDefined(this.state.assets.background.src) && this.state.assets.background.src.length > 0
            ?
            <div className="customer-scenario">
                <div className="background-container">
                    <img src={this.getImagePath(this.state.assets.background.src)} alt=""/>
                </div>
                <div className="screen-container">
                    <div className={`title-panel ${this.setClass()}`}>
                        <div className="title-content">
                            {this.state.assets.icon.src.length > 0
                                ? <div className="title-icon-container">
                                    <img src={this.getImagePath(this.state.assets.icon.src)} alt=""/>
                                </div>
                                : null
                            }
                            {
                                appHelper.isDefined(this.state.locale.series_title)
                                    ?
                                    <h1 dangerouslySetInnerHTML={{__html: this.state.locale.series_title}}/>
                                    :
                                    null
                            }
                            {
                                appHelper.isDefined(this.state.locale.title) && this.state.locale.title !== null && this.state.locale.title.length > 0
                                    ?
                                    <h2 dangerouslySetInnerHTML={{__html: this.state.locale.title}}/>
                                    :
                                    null
                            }
                            {
                                appHelper.isDefined(this.state.locale.description) && this.state.locale.description !== null && this.state.locale.description.length > 0
                                    ?
                                    <div dangerouslySetInnerHTML={{__html: this.state.locale.description}}/>
                                    :
                                    null
                            }

                            <br/>
                            <div className="inline-list">
                                <div className="inline-item">
                                    <Button label={this.getButtonLabel()}
                                            isDisabled={this.state.isDisabled}
                                            id={`${this.state.screen.screen_id}_button`}
                                            class="continue-btn"
                                            onClick={this.onProgressionClicked}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            : null
        );
    }
}

TitleScreen.propTypes = {
    screen: PropTypes.object.isRequired,
    biteCallbacks: PropTypes.object.isRequired,
    titles: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
    userData: PropTypes.object.isRequired,
};

TitleScreen.contextTypes = {
    router: PropTypes.object,

};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang:lang,
        titles: state.titles,
        userData: state.userData,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, appDataActions, trackingDataActions, userDataActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(TitleScreen);



/** WEBPACK FOOTER **
 ** ./src/components/screens/titleScreen/TitleScreen.js
 **/